'use client';

import { ReactNode, useEffect, useState } from 'react';
import { getPackagesPromo } from 'actions/packages';

import { Box } from '@chakra-ui/react';

import { useAppDispatch, useAppSelector } from 'store/hooks';

import { Loader } from 'ui';

interface ShopLayoutProps {
  children: ReactNode;
}
const ShopLayout = ({ children }: ShopLayoutProps): ReactNode => {
  const dispatch = useAppDispatch();
  const { isLoadingPromo, packagesPromo } = useAppSelector(
    (state) => state.packages
  );
  const [hasError, setHasError] = useState(false);
  const [hasAttemptedLoad, setHasAttemptedLoad] = useState(false);
  const isInitialLoading = packagesPromo === null && !hasError;

  useEffect(() => {
    if (!packagesPromo && !hasAttemptedLoad) {
      setHasAttemptedLoad(true);
      try {
        dispatch(getPackagesPromo());
      } catch (error) {
        console.error('Failed to load packages promo:', error);
        setHasError(true);
      }
    }
  }, [dispatch, packagesPromo, hasAttemptedLoad]);

  // Only show loader for a short time, then show content regardless
  useEffect(() => {
    const timer = setTimeout(() => {
      if (isInitialLoading && isLoadingPromo) {
        setHasError(true); // Force content to show if loading takes too long
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, [isInitialLoading, isLoadingPromo]);

  return (
    <Box mb={{ base: '50px', md: '70px', lg: '90px' }} w='100%'>
      {isInitialLoading && isLoadingPromo && !hasError ? (
        <Loader fixed />
      ) : (
        <>{children}</>
      )}
    </Box>
  );
};

export default ShopLayout;
